import { CheckCircleFilled } from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Tooltip } from '@/components/Tooltip';
import { ROUTE_PATH_PROPOSAL_REQUEST } from '@/modules/proposalRequest/contants/proposalRequest';

const CheckSymbolPartner = ({ isValid, translate, hideCheck, proposalId }) => {
  const { t } = useTranslation(translate || 'common');
  const { push } = useHistory();

  const handleClick = useCallback(() => {
    push(`${ROUTE_PATH_PROPOSAL_REQUEST}/${proposalId}/tools`);
  }, [proposalId, push]);

  return (
    <div>
      {!hideCheck &&
      <Tooltip title={!isValid ? t('proposalDetails.partnersAndWorkers.partners.fucProblem') : t('proposalDetails.partnersAndWorkers.partners.fucValidated')} placement="left"
        className={`${!isValid ? 'cursor-pointer' : null}`}>
        <CheckCircleFilled style={{fontSize: '20px'}} onClick={handleClick} className={classNames({ 'text-success': isValid }, { 'text-error': !isValid })}/>
      </Tooltip>}
    </div>
  );

};

CheckSymbolPartner.propTypes = {
  hideCheck: PropTypes.bool,
  translate: PropTypes.string,
  toCompare: PropTypes.string,
  isValid: PropTypes.bool,
  proposalId: PropTypes.string,
};

CheckSymbolPartner.defaultProps = {
  translate: 'proposalRequest'
};

export default memo(CheckSymbolPartner);
